import { compileTemplateBody } from "common/utils/templates";
import MarkdownParser from "common/components/MarkdownParser";

import { useClinic } from "client/clinics/hooks";

import styles from "../../styles/MarkdownText.module.less";

const useVariableParser = (value: string) => {
  const clinic = useClinic();
  return compileTemplateBody(value, { clinic_name: clinic.display_name });
};

type TextProps = {
  value: string;
};

const MarkdownText = ({ value }: TextProps) => {
  const content = useVariableParser(value);

  return <MarkdownParser.Inline className={styles.container} markdown={content || ""} />;
};

/**
 * MarkdownText component uses the Inline parser by default, which doesn't support all markdown like bulleted lists.
 * Adding a Block component that uses the default Markdown parser.
 */
const MarkdownTextBlock = ({ value }: TextProps) => {
  const content = useVariableParser(value);

  return <MarkdownParser className={styles.container} markdown={content || ""} />;
};

export default Object.assign(MarkdownText, { Block: MarkdownTextBlock });
